<div class="grid" style="margin-bottom: 30px">
  <div class="col-6 flex">
    <div class="hidden md:block">
      @if (displayGalleria) {
        <p-galleria
          [(visible)]="displayGalleria"
          [fullScreen]="true"
          [circular]="true"
          [value]="images"
          [showItemNavigators]="true"
          [showThumbnailNavigators]="true"
          [baseZIndex]="100000"
          (onClose)="hideImage()"
          [numVisible]="4"
          class="fullscreen-gallery">
          <ng-template pTemplate="item" let-item>
            <div>
              <div class="flex justify-content-center" style="width: 80vw">
                <img
                  [src]="item.url || './assets/images/fallback.png'"
                  alt="Gallerie"
                  style="max-height: 80vh; max-width: 80vw" />
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="thumbnail" let-item>
            <div class="mt-3" style="width: 100px">
              <img [src]="item.url || './assets/images/fallback.png'" alt="thumbnail" height="60" />
            </div>
          </ng-template>
        </p-galleria>
      } @else {
        <p-galleria
          class="small-gallery"
          [circular]="true"
          [value]="images"
          [showThumbnailNavigators]="false"
          [baseZIndex]="100000"
          [numVisible]="4">
          <ng-template pTemplate="item" let-item>
            <div>
              <div class="flex justify-content-center" style="width: 192px; background-color: #f2f4f1">
                <p-image
                  [preview]="true"
                  [src]="item.url || './assets/images/fallback.png'"
                  alt=""
                  height="108"
                  width="160"
                  (click)="displayImage()" />
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="thumbnail" let-item>
            <div>
              <div class="flex justify-content-center" style="width: 45px; background-color: #f2f4f1">
                <img [src]="item.url || './assets/images/fallback.png'" alt="thumbnail" height="25" />
              </div>
            </div>
          </ng-template>
        </p-galleria>
      }
    </div>
    <div class="flex flex-column justify-content-between p-3">
      <div>
        <div class="mb-2 attribute">{{'table.label' | translate}}:</div>
        <div
          style="max-height: 75px; overflow: hidden"
          [tp]="tplTitle"
          [tpPlacement]="'left'"
          [tpInteractive]="true"
          [tpPopperWidth]="'600px'">
          <div class="truncate">
            <p class="font-bold text-justify">{{ product?.title }}</p>
          </div>
          <ng-template #tplTitle let-hide>
            <div class="flex align-items-center text-justify p-2">
              <div style="max-height: 80vh; overflow-y: auto; padding-right: 10px">
                <p [innerHTML]="product?.title"></p>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <div>
        <div class="mb-2 attribute">{{ "detailProduct.category" | translate }}:</div>
        <div class="font-bold">
          {{ product?.category.categoryBreadCrumb }}
        </div>
      </div>
    </div>
  </div>
  <div class="col-2 flex overflow-hidden">
    <div class="flex flex-column justify-content-between p-3">
      <div>
        <div class="mb-2 attribute">{{ "detailProduct.brand" | translate }}:</div>
        <div class="font-bold">{{ product?.brand }}</div>
      </div>
      <div>
        <div class="mb-2 attribute">EAN:</div>
        <div class="font-bold">
          @for (ean of product?.ean; track $index) {
            {{ ean }}
          }
        </div>
      </div>
    </div>
  </div>
  <div class="col-4 flex">
    <div class="flex flex-column justify-content-between p-3" style="width: 100%;">
      <div>
        <div class="mb-2 attribute">{{ "detailProduct.description" | translate }}:</div>
        <div
          style="max-height: 75px; overflow: hidden"
          [tp]="tpl"
          [tpPlacement]="'left'"
          [tpInteractive]="true"
          [tpPopperWidth]="'600px'">
          <div class="truncate">
            <p class="font-bold text-justify">{{ product?.description }}</p>
          </div>
          <ng-template #tpl let-hide>
            <div class="flex align-items-center text-justify p-2">
              <div style="max-height: 80vh; overflow-y: auto; padding-right: 10px">
                <p [innerHTML]="product?.description"></p>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <div>
        @if (product?.sku) {
          <div class="mb-2 attribute">SKU:</div>
          <div class="font-bold">
            {{ product?.sku }}
          </div>
        } @else {
          <div class="mb-2 attribute">SKU:</div>
          <div class="font-bold">
            {{ product?.prid }}
          </div>
        }
      </div>
    </div>
  </div>
</div>
<p-divider> </p-divider>
<div class="mt-3">
  <div class="mb-3">
    <span class="font-bold inline-block" style="font-size: 1.1rem"> {{'global.spec' | translate}} </span>
  </div>
  <div>
    <div class="mb-3">
      <span class="flex align-items-end link font-bold" (click)="openAllTabs()">
        <span class="mr-1">
          {{ "global.openAll" | translate }}
        </span>
        <i class="pi pi-angle-double-right font-bold" style="font-size: 0.85rem"></i>
      </span>
    </div>
    <p-accordion [multiple]="true" [value]="activeIndex" expandIcon="pi pi-angle-right" collapseIcon="pi pi-angle-down">
      @for (tab of tabs; track $index) {
        <p-accordion-panel [value]="$index" >
          <p-accordion-header>
            <span class="flex align-items-center gap-2 w-full">
              <i [class]="tab.class"></i>
              <span class="font-bold white-space-nowrap">{{ tab.header | translate }}</span>
              <div>
                @if (tab.errors === 'invalid') {
                <p-tag severity="danger" value="{{ 'errors.invalid' | translate }}"> </p-tag>
              } @else if(tab.errors === 'awaiting'){
                <p-tag severity="warn" value="{{ 'errors.awaiting_download' | translate }}"></p-tag>
              } @else {
                <p-tag severity="success" value="{{ 'errors.valid' | translate }}"></p-tag>
              }
              </div>
            </span>
          </p-accordion-header>

          <p-accordion-content>
            <form [formGroup]="tab.form">
              <div class="grid">
                @for (attribute of tab.attributes; track $index) {
                  <div class="product-attribute" [class]="attribute.width == 6 ? 'col-6' : 'col-12'">
                    <div class="flex gap-2 mb-2 align-items-center line-height-2">
                      <span class="attribute-code">{{ attribute.attributeName }}</span>
                      <div>
                        @if (attribute.status?.toLowerCase() === "valid") {
                          <p-tag severity="success" value="{{ 'errors.valid' | translate }}"></p-tag>
                        } @else if (attribute.status?.toLowerCase() === "invalid") {
                          <p-tag severity="danger" value="{{ 'errors.invalid' | translate }}"></p-tag>
                        } @else if (attribute.status?.toLowerCase() === "processing") {
                          <p-tag severity="warn" value="{{ 'errors.processing' | translate }}"></p-tag>
                        } @else if (attribute.status?.toLowerCase() === "awaiting_download") {
                          <p-tag severity="warn" value="{{ 'errors.awaiting_download' | translate }}"></p-tag>
                        }
                      </div>
                      <ng-template
                        [ngTemplateOutlet]="tagref"
                        [ngTemplateOutletContext]="{ attribute: attribute, form: tab.form }">
                      </ng-template>
                    </div>

                    <div class="flex align-items-center w-full">
                      <div class="w-full flex">
                        @if (attribute.attributeType === "LONG_TEXT") {
                          <div (click)="handleInput(tab.form, attribute)" class="w-full">
                            <textarea rows="5" pTextarea [formControlName]="attribute.attributeCode"></textarea>
                          </div>
                        } @else if (attribute.attributeType === "LIST") {
                          <div (click)="handleInput(tab.form, attribute)" class="w-full">
                            <p-select
                              [formControlName]="attribute.attributeCode"
                              [options]="attribute.options"
                              optionLabel="label" />
                          </div>
                        } @else if (attribute.attributeCode === "Typology" && operator == false) {
                          <div (click)="handleInput(tab.form, attribute)" class="w-full">
                            <p-treeSelect
                              containerStyleClass="w-full"
                              [showClear]="true"
                              [options]="categories"
                              [formControlName]="attribute.attributeCode"
                              placeholder="{{ 'global.selectItem' | translate }}">
                              <ng-template #default let-node>
                                <div><span>{{ node.categoryLabelLoc }}</span></div>
                              </ng-template>
                              <ng-template #value let-node>
                                <div><span>{{ node.categoryBreadcrumbLoc }}</span></div>
                              </ng-template>
                            </p-treeSelect>
                          </div>
                        } @else if (attribute.attributeType === "MEDIA") {
                          <div class="flex-row" style="flex-flow: row wrap;">
                            <p-image
                              [src]="tab.form.get(attribute.attributeCode)?.value || './assets/images/fallback.png'"
                              height="100px" />
                          </div>
                        } @else if (attribute.attributeType === "PDF") {
                          @if (tab.form.get(attribute.attributeCode)?.value) {
                            <div class="mt-1">
                              <a class="document-link" target="_blank" [href]="tab.form.get(attribute.attributeCode)?.value">
                                <i class="pi pi-file-pdf mr-2"></i>PDF {{ attribute.attributeName }}
                              </a>
                            </div>
                          } @else {
                            <div class="mt-1" pTooltip="{{ 'productAttributes.noValue' | translate }}">
                              <a class="document-link" target="_blank">
                                <i class="pi pi-file-pdf mr-2"></i>PDF {{ attribute.attributeName }}
                              </a>
                            </div>
                          }
                        } @else {
                          <div (click)="handleInput(tab.form, attribute)" class="w-full">
                            <input
                              [formControlName]="attribute.attributeCode"
                              type="text"
                              pInputText
                              class="w-full block flex-grow-1" />
                          </div>
                        }
                      </div>
                      <div>
                        <ng-template #tpl>
                          <div class="flex align-items-center text-justify p-2" style="font-size: 11px">
                            {{ "productAttributes.referencedDetails" | translate }}
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </form>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>
</div>

<ng-template let-attribute="attribute" let-form="form" #tagref>
  @if ((isMasterProduct && user.operator) || !user.operator) {
    <div
      class="border-1 ml-2 cursor-pointer"
      style="border-radius: 5px; padding: 0.2rem 0.35rem"
      (click)="handleInput(form, attribute)"
      [ngClass]="{'disabled': attribute.status?.toLowerCase() === 'processing'}"
      [ngStyle]="{'pointer-events': attribute.status?.toLowerCase() === 'processing' ? 'none' : 'auto', 'opacity': attribute.status?.toLowerCase() === 'processing' ? '0.5' : '1'}">
      <i class="pi pi-pen-to-square" style="font-size: 10px"></i>
    </div>
  }

  @if (attribute.tag) {
    <div class="flex ml-2 white-space-nowrap justify-content-center align-items-center" style="gap: 7px">
      <div
        class="flex gap-1"
        style="font-size: 11px; padding: 4px 7px; border-radius: 6px; background-color: #9e9e9e; color: #f5f5f5">
        <img src="./assets/images/shop.svg" alt="shop" />
        <div>{{ attribute.tag }}</div>
      </div>
    </div>
  } @else if (attribute.referenced === "true") {
    <p-tag class="black-tag" [tp]="referenceTemplate" [tpPlacement]="'right'" [tpInteractive]="true" [tpPopperWidth]="'365px'">
      <svg xmlns="http://www.w3.org/2000/svg" style="width: 12px; height: 15px" viewBox="0 0 512 512">
        <path
          d="M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0L133.9 0c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0L487.4 0C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
          fill="#F5F5F5" />
      </svg>
      <span class="pl-2">
        {{ "detailProduct.reference" | translate }}
      </span>
    </p-tag>
    <ng-template #referenceTemplate>
      <div class="flex align-items-center text-justify p-2" style="font-size: 11px">
        {{ "productAttributes.referencedDetails" | translate }}
      </div>
    </ng-template>
  }
  @if (attribute.errorMessage) {
    <div class="flex justify-content-center">
      <p-button (onClick)="attribute.showMessage = true"
      icon="pi pi-exclamation-triangle"
      [label]="'productAttributes.attributeError' |translate"
      [pTooltip]="'productAttributes.tooltipError' | translate"
      tooltipPosition="right"
      [text]="true"
        severity="danger" />
      <p-dialog [header]="'productAttributes.attributeErrorModalHeader' |translate" [modal]="true" [(visible)]="attribute.showMessage" [style]="{ width: '50rem' }"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true"
        (onMaximize)="attribute.maximized = $event.maximized" (onHide)="attribute.maximized = false">
        <p>
          @if(attribute.maximized) {
            <div>{{attribute.errorMessage}}</div>
          } @else {
            <div style="max-width: 600px;" class = "truncated">
              {{attribute.errorMessage}}
            </div>
          }
        </p>
      </p-dialog>
    </div>

  }
</ng-template>
<div class="mt-5"></div>
@if (showButtons) {
  <div class="fixed-footer">
    <div class="absolute right-0" style="padding: 10px">
      <p-button
        type="button"
        label="{{ 'buttons.cancel' | translate }}"
        icon="pi pi-times-circle"
        [outlined]="true"
        severity="danger"
        class="pr-3"
        (click)="cancelEdit()" />
      <p-button
        type="button"
        label="{{ 'buttons.validate' | translate }}"
        icon="pi pi-check-square"
        (click)="sendAttributes()"
        [disabled]="formObligatory.controls['EANs/EAN']?.invalid"/>
    </div>
  </div>
}

<p-toast></p-toast>
<p-toast key="loading">
  <ng-template let-message pTemplate="headless">
    <div class="flex align-items-center p-3">
      <p-progressSpinner
        class="flex-1"
        styleClass="w-4rem h-4rem"
        strokeWidth="8"
        animationDuration=".5s" />
      <div class="flex-1 font-semibold">
        {{ message.summary | translate }}
      </div>
    </div>
  </ng-template>
</p-toast>
